export class Daily357InsuranceFeeDto {
    static instanceOf(obj) {
        if (obj === null || obj === undefined) {
            return false;
        }
        return ('day3' in obj &&
            'day5' in obj &&
            'day7' in obj &&
            typeof obj.day3 === 'number' &&
            typeof obj.day5 === 'number' &&
            typeof obj.day7 === 'number' &&
            Object.keys(obj).length === 3);
    }
}
